import { Checkbox } from "PFComponents/checkbox";
import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tile } from "PFComponents/tile";
import Toggle from "PFComponents/toggle/toggle";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { ReactNode } from "react";

import css from "./skills_bulk_edit_side_panel.module.scss";

type BooleanBulkSettingProps = {
  title: string;
  tooltip: string;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  valueLabel: ReactNode;
  value: boolean;
  onValueChange: (value: boolean) => void;
  error?: string;
};

export const BooleanBulkSetting = ({
  title,
  tooltip,
  enabled,
  onEnabledChange,
  valueLabel,
  value,
  onValueChange,
  error
}: BooleanBulkSettingProps) => (
  <Stack>
    <Tile paddingVariant="md" variant={error ? "error" : "default"}>
      <Stack>
        <Inline justifyContent="space-between" alignItems="center">
          <Toggle inline reversed description={title} checked={enabled} onChange={onEnabledChange} />
          <TooltipIcon content={tooltip} />
        </Inline>
        <Checkbox label={valueLabel} checked={value} onChange={onValueChange} disabled={!enabled} />
      </Stack>
    </Tile>
    {error && (
      <Inline>
        <Icon name="error" color="paletteRed1" />
        <Typography variant="labelRegular" className={css.error}>
          {error}
        </Typography>
      </Inline>
    )}
  </Stack>
);
